/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_Tab_TitleInputs */

const vi_report_debt_tab_title = /** @type {(inputs: Report_Debt_Tab_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Báo cáo công nợ`)
};

/**

* @param {Report_Debt_Tab_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_tab_title = /** @type {((inputs?: Report_Debt_Tab_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_Tab_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_tab_title(inputs)
});